module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.8457/images/homepage/hero-personas/thumbnail-15.webp"